import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';
import { shareReplay } from 'rxjs';
import { ConfigService } from '@app/services';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {

  private readonly translateService = inject(TranslateService);
  private readonly configService = inject(ConfigService);

  public readonly config$ = this.configService.config$.pipe(
    map(({ languages }) => languages),
    shareReplay(1),
  );

  public readonly currentLanguage$ = this.translateService.onLangChange.pipe(
    map((event) => event.lang),
    startWith(this.translateService.getCurrentLang()),
    shareReplay(1),
  );

}
